'use strict';

import { SystemStorageType } from '../App/model/system-storage-types';

/**
 * @ngdoc service
 * @name mx.shell.AuthBehaviorProviderService
 * @module mx.shell
 *
 * @description
 * Represents interface for Auth Behavior Provider.
 * The purpose of the service is to customize some aspects of authentication behavior.
 * <br><br><b>
 * The implementation of Auth Behavior Provider is not provided in Shell module and have to be provided by business application.</b>
 *
 */
export class AuthBehaviorProviderService {
	static $inject = ['$q', 'mx.shell.DataStorage'];
	constructor($q, dataStorage) {
		Object.assign(this, { $q, dataStorage });
		this._beforeDestroyCallbacks = [];
		this._sessionExpiredCallbacks = [];
		this._sessionEstablishedCallbacks = [];
	}

	onBeforeSessionDestroy(cb) {
		return this._addCallback(this._beforeDestroyCallbacks, cb);
	}

	async beforeSessionDestroy() {
		await this._requestCallbacksWithMaxTime(this._beforeDestroyCallbacks);
		this.dataStorage.getStorage(SystemStorageType.LocalStorage).cleanAllWithExpirationDate();
		this._beforeDestroyCallbacks = [];
	}

	async sessionExpired() {
		await this._requestCallbacksWithMaxTime(this._sessionExpiredCallbacks);
		this._sessionExpiredCallbacks = [];
	}

	onSessionExpired(cb) {
		return this._addCallback(this._sessionExpiredCallbacks, cb);
	}

	onSessionEstablished(cb) {
		return this._addCallback(this._sessionEstablishedCallbacks, cb);
	}

	async sessionEstablished(session, isNew) {
		await this._requestCallbacksWithMaxTime(this._sessionEstablishedCallbacks, 10000, { session, isNew });
		this._sessionEstablishedCallbacks = [];
	}

	_addCallback(callbacksArray, callback) {
		if (typeof callback !== 'function') {
			return null;
		}

		callbacksArray.push(callback);
		return () => {
			const index = callbacksArray.indexOf(callback);
			if (index >= 0) {
				callbacksArray.splice(index, 1);
			}
		};
	}

	async _requestCallbacksWithMaxTime(callbacks, maxTime = 10000, ...args) {
		const maxTimePromise = new Promise((resolve) => setTimeout(resolve, maxTime));

		const callbacksPromise = Promise.all(
			callbacks.map(async (callback) => {
				try {
					await callback(...args);
				} catch (e) {
					console.error(e);
				}
			})
		);

		return Promise.any([callbacksPromise, maxTimePromise]);
	}
}
